import { Component } from "react";
import Dropdown from "react-dropdown";
import "react-dropdown/style.css";
import { injectIntl, IntlShape } from "react-intl";
type Props = {
  pregameOptions: Record<string, any>;
  disablePreGameFilter: boolean;
  togglePreGameEventsOnly: (...args: Array<any>) => any;
  asianPreGameEventsOnly: boolean;
  intl: IntlShape;
};

class PreGame extends Component<Props> {
  render() {
    const {
      pregameOptions,
      disablePreGameFilter,
      togglePreGameEventsOnly,
      asianPreGameEventsOnly,
      intl,
    } = this.props;
    return (
      <div className="global-event-navigation--pre-game-only">
        <Dropdown
          id="pregame"
          name="pregame"
          options={pregameOptions}
          className={`navigation-sorting__dropdown ${
            disablePreGameFilter === true ? "disabled" : ""
          } `}
          onChange={e => togglePreGameEventsOnly(e)}
          value={
            asianPreGameEventsOnly
              ? intl.formatMessage({
                  id: "global-events-navigation-pregame-only",
                })
              : intl.formatMessage({
                  id: "global-events-navigation-all-events",
                })
          }
        />
      </div>
    );
  }
}

export default injectIntl(PreGame);
